import taskManagerApi from "@/features/shared/services/taskManagerApi";
const API_ROUTE = "/employment_contract_type";
const extractErrorMessage = (error) => {
    if (error instanceof Error) {
        const serverError = error?.response?.data?.error;
        const serverMessage = error?.response?.data?.message;
        if (serverError) {
            const details = Array.isArray(serverError.details)
                ? serverError.details.join(" ")
                : serverError.details;
            return details ?? serverError.message ?? error.message;
        }
        if (serverMessage) {
            return serverMessage;
        }
        return error.message;
    }
    return "Une erreur inattendue est survenue.";
};
export const fetchContractTypes = async (page = 1, filters = {}, limit = 10) => {
    try {
        const params = {
            page,
            limit,
        };
        if (filters.search) {
            params.search = filters.search;
        }
        const response = await taskManagerApi.get(API_ROUTE, { params });
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const fetchContractTypeByCode = async (code) => {
    try {
        const response = await taskManagerApi.get(`${API_ROUTE}/${code}`);
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const createContractType = async (payload) => {
    try {
        const response = await taskManagerApi.post(API_ROUTE, payload);
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const updateContractType = async ({ code, contractType }) => {
    try {
        await taskManagerApi.put(`${API_ROUTE}/${code}`, contractType);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const deleteContractType = async (code) => {
    try {
        await taskManagerApi.delete(`${API_ROUTE}/${code}`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const fetchAllContractTypes = async () => {
    const { items } = await fetchContractTypes(1, {}, 200);
    return items;
};
